import { observer } from "mobx-react-lite";

import { BodyInstructionsField } from "src/components/BodyInstructionsField";
import { RegularHeaderFields } from "src/components/RegularHeaderFields";

import {
  BaseDetailedWorkoutItemGroup,
  type WorkoutItemGroupProps,
} from "./BaseDetailedWorkoutItemGroup";

export const RegularDetailedWorkoutItemGroup = observer(
  function RegularDetailedWorkoutItemGroup(props: WorkoutItemGroupProps) {
    return (
      <BaseDetailedWorkoutItemGroup
        {...props}
        header={
          <RegularHeaderFields workoutItemId={props.item.workoutItemId} />
        }
        body={
          <BodyInstructionsField workoutItemId={props.item.workoutItemId} />
        }
      />
    );
  },
);
